<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary">
            <div class="row">
              <div class="col-8 d-flex align-items-center gap-3">
                <div>
                  <h4 class="card-title mt-0">Client List</h4>
                  <p class="card-category">Manage your clients</p>
                </div>
                <div class="flex-grow-1" style="max-width: 300px;">
                  <app-search [(value)]="searchTerm"
                              (valueChange)="onSearchChange()"
                              placeholder="Search">
                  </app-search>
                </div>
              </div>
              <div class="col-4  text-end">
                <button mat-raised-button type="button" class="btn btn-success pull-right" [routerLink]="['/clients/create']">Add New Client</button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover table-striped">
                <thead class=" text-primary">
                    <th>ID</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Actions</th>
                </thead>
                <tbody>
                  <tr *ngFor="let client of clients">
                    <td>{{ client.id }}</td>
                    <td>{{ client.fullName }}</td>
                    <td>{{ client.phoneNumber }}</td>
                    <td>{{ client.address }}</td>
                    <td>
                        <i class="material-icons text-info" style="cursor: pointer;" [routerLink]="['/clients/details', client.id]" title="View Details">visibility</i>
                        <i class="material-icons text-danger" style="cursor: pointer;" (click)="deleteClient(client.id)" title="Delete">delete</i>
                        <i class="material-icons text-warning" style="cursor: pointer;" mat-icon-button [routerLink]="['/clients/edit', client.id]" title="Edit">edit</i>
                        <i class="material-icons text-primary" style="cursor: pointer;" (click)="openAttachmentsModal(client.attachments, client)" title="Attachments">folder</i>
                        <i class="material-icons" style="cursor: pointer; color: #1976D2;" (click)="openClientNotesModal(client)" title="Notes">description</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <mat-paginator [length]="totalItems"
                             [pageSize]="pageSize"
                             [pageSizeOptions]="[5, 10, 25, 50]"
                             (page)="onPageChange($event)">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
